import {
  AIUserFeedback,
  CreateAIUserFeedbackData,
} from '@dc-shared-web/hooks/api/ai-user-feedback/types'
import { AxiosInstance } from 'axios'

export const createAIUserFeedback = async (
  apiClient: AxiosInstance,
  feedback: CreateAIUserFeedbackData,
  params?: {
    checklist_template_uuid?: string
    question_ref_id?: string
  }
): Promise<AIUserFeedback> => {
  const { data } = await apiClient.post<AIUserFeedback>(
    '/api/ai-user-feedback',
    feedback,
    { params }
  )

  return data
}
